<template>
  <div class="annualMeetingConstructDetail">
    <heads></heads>
    <div class="container">
      <div class="container-top">
        <div class="swiper-wrapper">
          <!-- 轮播图 -->
          <swiper
            v-if="imgList.length > 0"
            :options="swiperOptionTop"
            class="gallery-top"
            ref="swiperTop"
          >
            <swiper-slide
              class="slide-1"
              v-for="(item, index) in imgList"
              :key="index"
            >
              <div class="swiper-content">
                <img
                  v-bind:style="{ backgroundImage: 'url(' +'\'' + item.path +'\'' + ')' }"
                />
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-button-next swiper-button-gray"
            slot="button-next"
          ></div>
          <div
            class="swiper-button-prev swiper-button-gray"
            slot="button-prev"
          ></div>
        </div>
      </div>
      <div class="container-bottom" ref="containerBottomRef">
        <div class="article">
          <!-- <div class="company-icon">
            <img
              src="https://iproduct.damaotuanjian.com/PRODUCT/4DB685E0-B95C-11EC-A1FE-E1C1E28C7A74.png-s2_webp"
            />
          </div> -->
          <!-- <div class="flow">团建案例 2022-01-13 | 浏览 108</div> -->
          <div class="title">腾讯新闻 | 迎新春庙会+线上表彰2日年会</div>
          <div class="subtitle">
            已经和合作很多次了，一如既往的专业，活动都很棒，好的合作伙伴就是让人放心，棒棒哒。
          </div>
          <!-- <div class="tag"><span>主题团建</span><span>旅行团建</span></div> -->
          <div class="article-content">
            <!--文章 -->
            <video
              controls="controls"
              src="https://ivideo.damaotuanjian.com/VIDEO/DA374980-BBD4-11EC-847C-7B0E5C9836BD.mp4"
            ></video>
            <div class="article-content-item">
              <p class="">活动进行中</p>
              <img
                src="https://iproduct.damaotuanjian.com/PRODUCT/36470E50-B963-11EC-A1FE-E1C1E28C7A74.jpg-s1_webp"
              />
            </div>
            <div class="article-content-item">
              <!-- <p class="">活动进行中</p> -->
              <img
                src="https://iproduct.damaotuanjian.com/PRODUCT/36470E50-B963-11EC-A1FE-E1C1E28C7A74.jpg-s1_webp"
              />
            </div>
            <div class="article-content-item">
              <!-- <p class="">活动进行中</p> -->
              <img
                src="https://iproduct.damaotuanjian.com/PRODUCT/36470E50-B963-11EC-A1FE-E1C1E28C7A74.jpg-s1_webp"
              />
            </div>
            <div class="article-content-item">
              <p class="">活动圆满结束</p>
              <img
                src="https://iproduct.damaotuanjian.com/PRODUCT/36470E50-B963-11EC-A1FE-E1C1E28C7A74.jpg-s1_webp"
              />
            </div>
          </div>
        </div>
        <div class="construct-information" ref="caseInformationRef">
          <div class="large-title large-title1">搭建费用
            <div class="long-line1"></div>
          </div>
          <div class="construct-fee">
            <span class="construct-fee-0">14.</span>
            <span class="construct-fee-1">2万</span>
            <span class="construct-fee-2">元起</span>
          </div>
          <div class="large-title">搭建概述
            <div class="long-line"></div>
          </div>
          <div class="construct-overview">
            <div class="construct-overview-item">
              <span class="title">适用人数：</span><span>250</span>
            </div>
            <div class="construct-overview-item">
              <span class="title">搭建特色：</span><span>暗场搭建</span>
            </div>
            <div class="construct-overview-item">
              <span class="title">灯光效果：</span><span>灯光组合</span>
            </div>
            <div class="construct-overview-item">
              <span class="title">音响效果：</span><span>线阵音响</span>
            </div>
            <div class="construct-overview-item">
              <span class="title">舞台尺寸：</span><span>5米×20米</span>
            </div>
          </div>
          <div class="large-title">参考流程
            <div class="long-line"></div>
          </div>
          <div class="reference-schedule">
            <el-timeline>
              <el-timeline-item
                timestamp=""
                placement="top"
                class="tour-header"
              >
                <!-- :icon="activity.icon"
                      :type="activity.type"
                      :color="activity.color"
                      :size="activity.size" -->
              </el-timeline-item>
              <el-timeline-item timestamp="13:10" placement="top">
                <div>到达<span class="time">1.5h</span></div>
              </el-timeline-item>
              <el-timeline-item timestamp="13:10" placement="top">
                <div>到达<span class="time">1.5h</span></div>
              </el-timeline-item>
              <el-timeline-item timestamp="13:10" placement="top">
                <div>到达<span class="time">1.5h</span></div>
              </el-timeline-item>
              <el-timeline-item timestamp="13:10" placement="top"
              :icon="activity.icon">
                <div>到达<span class="time">1.5h</span></div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="large-title" ref="relatedProductsTitleRef">
           免费定制方案
          <div class="long-line"></div>
        </div>
          <div
            class="free-booking"
            ref="freeBookingRef"
            :class="
              freeBookingStyle == 1
                ? 'free-booking1'
                : 'free-booking2'
            "
            :style="freeBookingStyle == 2 ? { top: topHeight } : ''"
          >
            
            <div class="free-booking-content">
            <div class="free-booking-item">
              <span class="txt">年会人数</span>
              <el-select v-model="form.annualMeetingNumber" placeholder="年会人数">
                <el-option
                  v-for="(item, index) in annualMeetingNumberType"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="free-booking-item">
              <span class="txt">年会类型</span>
              <el-select v-model="form.annualMeetingType" placeholder="年会类型">
                <el-option
                  v-for="(item, index) in annualMeetingType"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="free-booking-item">
              <span class="txt">年会天数</span>
              <el-select v-model="form.annualMeetingDay" placeholder="年会天数">
                <el-option
                  v-for="(item, index) in annualMeetingDayType"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="free-booking-item free-booking-item2">
              <span class="txt">联系人</span>
              <el-input
                v-model="form.contact"
                placeholder="联系人"
                style="display: inline"
              ></el-input>
            </div>
            <div class="free-booking-item free-booking-item2">
              <span class="txt request">联系电话</span>
              <el-input
                v-model="form.mobile"
                placeholder="联系电话"
                style="display: inline"
              ></el-input>
            </div>
            <div class="free-booking-item">
              <span class="txt request">验证码</span>
              <div class="sendCode">
                <el-input
                  v-model="form.verificationCode"
                  placeholder="4位验证码"
                  style="display: inline"
                ></el-input>
                <span class="txt2">短信验证</span>
              </div>
            </div>
              <div class="submit-button">
                <div>提交年会需求</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="requireDialogVisible" width="0%">
      <rquirementsForm
        :dialogVisible="requireDialogVisible"
        :dataForm="dataForm"
        v-on:getRequireDialogVisible="closeRequireDialogVisible"
      ></rquirementsForm>
    </el-dialog>
    <homeFoots></homeFoots>
   <quickContact></quickContact>
  </div>
</template>
<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import rquirementsForm from "../comment/rquirementsForm.vue";
import{ Swiper } from "vue-awesome-swiper";
import quickContact from "@/components/comment/quickContact.vue";
import { handlePicPlusPre} from "@/util/util.js";
export default {
  name: "annualMeetingConstructDetail",
  data() {
    return {
      id: 0,
      loading: false,
      // 高度计算参数
      freeBookingStyle: 3,
      topHeight: "0px",
      dataForm: {
        title: "",
      },
      // 提交表单
      form: {
        annualMeetingNumber: "",
        annualMeetingType: "",
        annualMeetingDay: "",
        contact: "",
        mobile: "",
        verificationCode: "",
        wxNumber: "",
        description: "",
      },
      annualMeetingNumberType: [
        {
          id: 1,
          name: "25人以下",
        },
        {
          id: 2,
          name: "25-50人",
        },
        {
          id: 3,
          name: "50-100人",
        },
      ],
      annualMeetingType: [
        {
          id: 1,
          name: "300元以下",
        },
        {
          id: 2,
          name: "300-500",
        },
        {
          id: 3,
          name: "500-1000",
        },
      ],
      annualMeetingDayType: [
        {
          id: 1,
          name: "半天",
        },
        {
          id: 2,
          name: "一天",
        },
        {
          id: 3,
          name: "两天",
        },
      ],
      activity: {
          size: 'large',
          type: 'primary',
          icon: 'el-icon-eleme',
          color: '#0bbd87'
      },
      imgList: [
        {
          path: "https://iproduct.damaotuanjian.com/PRODUCT/F1FE75E0-28C0-11EC-8FC7-7DEEAC306FC3.jpg-s2_webp",
        },
        {
          path: "https://iproduct.damaotuanjian.com/PRODUCT/F1FE75E0-28C0-11EC-8FC7-7DEEAC306FC3.jpg-s2_webp",
        },
        {
          path: "https://iproduct.damaotuanjian.com/PRODUCT/F1FE75E0-28C0-11EC-8FC7-7DEEAC306FC3.jpg-s2_webp",
        },
        {
          path: "https://iproduct.damaotuanjian.com/PRODUCT/97FA4220-4985-11EA-960A-63B96F7975FC-s2_webp",
        },
        {
          path: "https://iproduct.damaotuanjian.com/PRODUCT/97FA4220-4985-11EA-960A-63B96F7975FC-s2_webp",
        },
        {
          path: "https://iproduct.damaotuanjian.com/PRODUCT/97FA4220-4985-11EA-960A-63B96F7975FC-s2_webp",
        },
      ],
      height: 0,
      activityIndex: 0,
      swiperLoading: false,
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 1,
        centeredSlides: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        swiperLoading: false,
        on: {
          init() {
            this.setTranslate(0);
          },
          transitionStart() {
            // 开始translate之前触发
            // 如果是第一张
            if (this.activeIndex == 0) {
              this.setTranslate(0); // 因为左边会空出一张图的距离，所以设置位移为0
            }
          },
        },
      },
      // swiperOptionThumbs: {
      //   autoplay: true,
      //   direction: "vertical",
      //   spaceBetween: 20,
      //   slidesPerView: 3,
      //   centeredSlides: true,
      //   touchRatio: 0.2,
      //   loop: true,
      //   slidesPerview: "auto",
      //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
      //   observeParents: true, //修改swiper的父元素时，自动初始化swiper
      //   slideToClickedSlide: true,
      // },
    };
  },
  components: {
    heads,
    homeFoots,
    // Swiper, 
    // SwiperSlide,
    rquirementsForm,
    quickContact
  },
  computed: {},
  methods: {
    // fomateDate,
    submit() {},
    closeRequireDialogVisible(val) {
      this.requireDialogVisible = val;
    },

    // 计算免费定制的显示
    handleScrollx() {
      let containerBottomBottom =
        this.$refs.containerBottomRef.getBoundingClientRect().bottom;
      let containerBottomTop =
        this.$refs.containerBottomRef.getBoundingClientRect().top;
      let caseInformationHeight = this.$refs.caseInformationRef.offsetHeight;
      let relatedProductsHeight = this.$refs.freeBookingRef.offsetHeight;
      let condition1 = containerBottomTop + caseInformationHeight;
      // console.log(condition1);
      // console.log(caseInformationHeight);
      // console.log(containerBottomBottom - relatedProductsHeight - 60);
      if (
        condition1 <= 0 &&
        containerBottomBottom - relatedProductsHeight - 100 >= 0
      ) {
        this.freeBookingStyle = 1;
        return;
      } else {
        if (condition1 >= 0) {
          this.freeBookingStyle = 3;
        } else {
          this.freeBookingStyle = 2;
        }
      }
      // // 计算触底位置
      // console.log(condition1);
      // console.log(containerBottomBottom);
      // 默认计算触顶位置
      this.topHeight = "";

      // // 计算触底位置
      // console.log(relatedProductsHeight);
      // // 数据大于3条才会触发
      if (containerBottomBottom - relatedProductsHeight - 100 < 0) {
        let containerBottomRef = this.$refs.containerBottomRef.offsetHeight;
        this.topHeight =
          containerBottomRef - relatedProductsHeight - 100 + "px";
      }
    },
    initSwiper(){
      const _this = this;
      new Swiper('.swiper-wrapper',{
        swiperOptionTop:this.swiperOptionTop
      })
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.initSwiper()
    })
    window.addEventListener("scroll", this.handleScrollx, true);
  },
  created() {},
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>
<style scoped>
.container {
  width: 100%;
}
.container-top {
  height: 430px;
  margin-top: 0px;
}
.container-top .swiper-content {
  /* height: 430px; */
}
.container-top .swiper-slide-active {
  /* z-index: 10;
  position: relative;
  left: -30px; */
  /* margin: 0px 100px; */
}
.swiper-wrapper {
  min-width: 600px;
  width: 100%;
}
.swiper-wrapper .swiper-container {
  /* display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #fff; */
}

.swiper-wrapper .swiper-content img {
  height: 100%;
  width: 100%;
  margin: 0;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
}
.swiper-wrapper .swiper-slide {
  width: 632px !important;
  height: 430px;
}
/* .swiper-wrapper .swiper-slide-prev{
  position: relative;
  left:-215px;
}
.swiper-wrapper .swiper-slide-active{
  position: relative;
  left:-90px;
}
.swiper-wrapper .swiper-slide-next{
  position: relative;
  left:35px;
} */
.swiper-wrapper .swiper-content {
  width: 632px;
  height: 430px;
  margin: 0px !important;
}
/*swiper*/
.swiper-wrapper .swiper-button-gray {
  z-index: 1000;
  transition: all 0.2s ease-in-out;
  opacity: 0;
  color: #fff7;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 30px;
}
.swiper-wrapper:hover .swiper-button-gray {
  z-index: 1000;
  transition: all 0.2s ease-in-out;
  opacity: 1;
  color: #fff7;
  font-size: 14px;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 30px;
}
/* .gallery-top {
  height: 100% !important;
  width: 100%;
}
.gallery-top .slide-1{
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.gallery-top .slide-1  a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.gallery-thumbs {
  position: absolute;
  right: 50px;
  top: 150px;
  width: 100px;
  height: 190px;
  padding: 0 5px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
} */
/* 下方布局 */
.container-bottom {
  display: flex;
  flex-direction: row;
  position: relative;
  min-height: 1000px;
  width: 1060px;
  margin: 0 auto;
}

/* 左边 */
.container-bottom .article {
  display: flex;
  flex-direction: column;
  width: 660px;
  background-color: #fff;
  position: relative;
  text-align: left;
}
.container-bottom .article .company-icon {
  position: absolute;
  height: 140px;
  left: 0;
  top: -84px;
  background: #fff;
  box-shadow: 0 2px 20px 0 rgb(0 0 0 / 10%);
  z-index: 1000;
}
.article .company-icon img {
  background-size: cover;
  height: 140px;
  background-repeat: no-repeat;
}
.article .flow {
  font-size: 14px;
  color: #999;
  padding-top: 42px;
  text-align: right;
}
.article .title {
  font-weight: 700;
  font-size: 36px;
  color: #222;
  padding-top: 52px;
  line-height: 80px;
  border-bottom: 1px solid #ececec;
}
.article .subtitle {
  padding: 30px 0 10px 0px;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  text-align: justify;
  line-height: 28px;
}
.article .tag {
  display: flex;
  flex-direction: row;
}
.article .tag span {
  background: #fff;
  border: 1px solid #e8e8e8;
  height: 16px;
  line-height: 16px;
  border-radius: 13px;
  padding: 0 10px;
  font-size: 12px;
  color: #999;
  margin-right: 10px;
}
.article .article-content {
}
.article .article-content video {
  width: 325px;
  height: 217px;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  margin-top: 30px;
}
.article-content-item {
}
.article-content-item p {
  font-size: 14px;
  color: #222;
  text-align: justify;
  line-height: 24px;
  padding: 16px 0;
}
.article-content-item img {
  width: 100%;
  display: block;
  margin-bottom: 8px;
}
/* 右边 */
.container-bottom .construct-information {
  position: absolute;
  width: 360px;
  top: 40px;
  right: 0;
}
.construct-information .large-title {
  font-size: 20px;
  color: #222;
  display: block;
  font-weight: 700;
  text-align: left;
  position: relative;
}
.construct-information .long-line{
    border-bottom: 1px solid #ececec;
    position: absolute;
    left: 90px;
    top: 12px;
    right: 0;
}
.construct-information .long-line1{
    border-bottom: 1px solid #ececec;
    position: absolute;
    left: 90px;
    top: 12px;
    right: 0;
}
.construct-information .long-line2{
    border-bottom: 1px solid #ececec;
    position: absolute;
    left: 90px;
    top: 12px;
    right: 0;
}
.construct-information .long-line3{
    border-bottom: 1px solid #ececec;
    position: absolute;
    left: 90px;
    top: 12px;
    right: 0;
}
.construct-information > div {
  margin-bottom: 20px;
}
.construct-information .large-title1 {
  margin-bottom: 10px;
}
.construct-information .construct-fee {
  display: flex;
  flex-direction: row;
  width: 360px;
  flex-wrap: wrap;
  font-weight: 700;
  align-items: flex-end;
  margin-bottom: 10px;
  
}
.construct-information .construct-fee-0 {
  color:#f9541c;
  font-size: 28px;
}
.construct-information .construct-fee-1 {
  color:#f9541c;
  font-size: 20px;
}
.construct-information .construct-fee-2 {
  color:#666;
  font-size: 20px;
}
.construct-overview{
  display: flex;
  flex-direction: column;
  align-items: flex-start;

}
.construct-overview-item{
  margin:  10px 0px;
}
.construct-overview-item .title{
  font-weight: 700;
}
.construct-information .reference-schedule {
}
.construct-information .reference-schedule .tour-header {
}
.construct-information .reference-schedule >>> .el-timeline-item__timestamp {
  position: absolute;
  left: -50px;
}
.construct-information .reference-schedule >>> .el-timeline-item__content > div {
  position: absolute;
  left: 30px;
  font-size: 14px;
  color: #222;
}
.construct-information .reference-schedule >>> .el-timeline-item__content > div .time {
  /* position: absolute;
  left: 30px; */
  font-size: 14px;
  padding-left: 10px;
  color: #359ff8;
}
.construct-information .reference-schedule >>> .el-timeline {
  position: relative;
  left: 100px;
  margin-top: 20px;
}
.construct-information .reference-schedule >>> .el-timeline-item {
  padding-bottom: 30px;
}

.construct-information .free-booking .free-booking-content {
}
.construct-information .free-booking .free-booking-content img {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  transition: all 0.3s ease-in-out;
}
.free-booking-item {
  position: relative;
  padding: 0 0 9px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
}
.free-booking-item .txt {
  display: inline;
  flex: 47;
  text-align: right;
  padding: 10px 5px 10px 0px;
}
.free-booking-item >>> div {
  flex: 100;
}
.free-booking-content .title {
  font-size: 18px;
  color: #222;
  text-align: left;
  display: block;
  line-height: 30px;
  font-weight: 700;
  display: block;
  padding: 10px 0;
}
.free-booking1 {
  position: fixed;
  top: 80px;
}
.free-booking2 {
  position: absolute;
}
.free-booking-content .tags {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.free-booking-content .tag-left {
  font-size: 14px;
  color: #666;
  line-height: 22px;
}
.free-booking-content .tag-right span {
  /* margin-top: -10px; */
  font-weight: 700;
  font-size: 24px;
  color: #f9541c;
}
.free-booking-content .tag-right span::after {
  content: "元起/人";
  font-weight: 700;
  font-size: 12px;
  color: #666;
  text-align: left;
  line-height: 28px;
}

.free-booking-content .submit-button {
  display: flex;
  flex-direction: row;
  position: relative;
  margin: 20px 0px;
}
.submit-button > div {
  width: 320px;
  position: absolute;
  line-height: 50px;
  outline: none;
  background: none;
  border: none;
  height: 50px;
  cursor: pointer;
  color: #FFEBBF;
  font-size: 16px;
  font-weight: 700;
  background-color: #f9541c;
  border-radius: 6px;
  text-align: center;
}
p,
span {
  text-align: left;
}
.construct-information .reference-schedule >>>.el-icon-eleme {
  background: url("../../assets/pic/yellow-ball.png") center no-repeat;
  width: 14px;
}
.construct-information .reference-schedule >>>.el-icon-eleme:before {
  content: "\8d3a";
  font-size: 14px;
  visibility: hidden;
}

/* el-select 样式 */
.free-booking-item >>> .el-input__inner,
.free-booking-item >>> .el-input__suffix {
  background-color: #f8f8f8;
}
.free-booking .free-booking-item2 >>> .el-input__inner {
  width: 220px !important;
}
.free-booking-item >>> .el-input__inner {
  border: none;
  width: 220px !important;
  background-color: #f8f8f8;
}
.free-booking-item .sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 155px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: #f9541c;
  /* opacity 0-1 控制透明度 */
  opacity: 0.2;
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.sendCode .txt-active {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: #f9541c;
  opacity: 1;
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.request::before {
  content: "*";
  color: red;
  position: relative;
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.free-booking-item .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.free-booking-item .txt {
  padding-top: 10px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}
</style>




// WEBPACK FOOTER //
// src/components/annualMeeting/annualMeetingConstructDetail.vue